<template>
  <div>
    <table>
      <tbody>
        <tr>
          <td rowspan="2" class="title">안전보건교육일지</td>
          <td rowspan="2" class="titleCell bordered" style="width: 33px; border-bottom: 0">결<br /><br /><br />재</td>
          <td class="titleCell signTitle bordered">안전관리자</td>
          <td class="titleCell signTitle bordered">관리책임자</td>
        </tr>
        <tr>
          <td class="signBody bordered">
            <div style="height: 80px">
              <img v-if="!!form.sign1.sign" :src="form.sign1.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td class="signBody bordered">
            <div style="height: 80px">
              <img v-if="!!form.sign2.sign" :src="form.sign2.sign" class="w-full h-full object-contain" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="contentTable" style="page-break-after: always">
      <tbody>
        <tr>
          <td class="titleCell">사업장명</td>
          <td colspan="2">{{ form.stdInfo.field_name }}</td>
          <td class="titleCell">교육일시</td>
          <td colspan="2">{{ form.inputA_4 }}, {{ form.inputA_5 }} ~ {{ form.inputA_6 }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육명</td>
          <td colspan="2">{{ form.inputA_3 }}</td>
          <td class="titleCell">교육구분</td>
          <td colspan="2">{{ !!form.inputA_1 ? form.inputA_1.value : "" }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육장소</td>
          <td :colspan="form.inputA_8.includes('직접입력') ? 6 : 2">{{ form.inputA_7 }}</td>
          <td v-if="!form.inputA_8.includes('직접입력')" class="titleCell">교육내용 반영 재해형태</td>
          <td v-if="!form.inputA_8.includes('직접입력')" colspan="2">{{ form.inputA_8.join(", ") }}</td>
        </tr>
        <tr v-if="form.inputA_8.includes('직접입력')">
          <td class="titleCell">교육내용 반영 재해형태</td>
          <td colspan="3">{{ form.inputA_8.join(", ") }}</td>
          <td class="titleCell">직접입력</td>
          <td colspan="2">{{ form.inputA_17 }}</td>
        </tr>
        <tr>
          <td class="titleCell">대상(작업명)</td>
          <td colspan="6">{{ !!form.inputA_2 ? form.inputA_2.value : "" }}</td>
        </tr>

        <tr>
          <td class="titleCell" rowspan="3">교육실시자</td>
          <td class="titleCell">교육실시자 성명</td>
          <td colspan="4">{{ form.inputA_9 }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육 실시자 소속</td>
          <td colspan="4">{{ form.inputA_10 }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육 실시자 직책</td>
          <td colspan="4">{{ form.inputA_11 }}</td>
        </tr>

        <tr>
          <td class="titleCell" rowspan="3">교육인원</td>
          <td class="titleCell">교육 대상</td>
          <td colspan="4">{{ form.inputA_12 }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육 실시 인원(명)</td>
          <td colspan="4">{{ form.inputA_13 | comma }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육 미실시 인원(명)</td>
          <td colspan="4">{{ form.inputA_14 | comma }}</td>
        </tr>

        <tr class="print-container">
          <td class="titleCell">교육내용</td>
          <td colspan="5" style="white-space: pre-wrap">{{ form.inputA_15 }}</td>
        </tr>
        <tr class="print-container">
          <td class="titleCell">근로자 의견</td>
          <td colspan="5" style="white-space: pre-wrap">{{ form.inputA_16 }}</td>
        </tr>
      </tbody>
    </table>

    <!--참석자 명단-->
    <h1 class="titleFull">안전교육 참석자 명단</h1>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-6 flex items-start">
        <div class="label-text mr-4 mt-2">교육구분</div>
        <span class="print-input"> {{ !!form.inputA_1 ? form.inputA_1.value : "" }} </span>
      </div>
      <div class="col-span-6 flex items-start">
        <div class="label-text mr-4 mt-2">교육일</div>
        <span class="print-input"> {{ form.inputA_4 }}, {{ form.inputA_5 }} ~ {{ form.inputA_6 }} </span>
      </div>
    </div>

    <table style="margin-top: 24px" class="pageBreak">
      <tr>
        <td style="width: 50%; padding-right: 5px">
          <table class="attendeeTable">
            <tbody>
              <tr>
                <td class="titleCell">No.</td>
                <td class="titleCell">소속</td>
                <td class="titleCell">직종</td>
                <td class="titleCell">성명</td>
                <td class="titleCell">서명</td>
                <td class="titleCell">비고</td>
              </tr>
              <tr v-for="index in 20" :key="index">
                <td>{{ index }}</td>
                <td>{{ typeof form.signatureList[index - 1] !== "undefined" ? form.signatureList[index - 1].target : "" }}</td>
                <td>{{ typeof form.signatureList[index - 1] !== "undefined" ? form.signatureList[index - 1].class : "" }}</td>
                <td>{{ typeof form.signatureList[index - 1] !== "undefined" ? form.signatureList[index - 1].name : "" }}</td>
                <td style="width: 1%; white-space: nowrap; min-width: 90px; padding: 2px">
                  <img v-if="typeof form.signatureList[index - 1] !== 'undefined'" height="50" :src="form.signatureList[index - 1].sign" />
                </td>
                <td>{{ typeof form.signatureList[index - 1] !== "undefined" ? form.signatureList[index - 1].note : "" }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <!--<td style="width: 10px;"></td>-->
        <td style="width: 50%; padding-left: 5px">
          <table class="attendeeTable">
            <tbody>
              <tr>
                <td class="titleCell">No.</td>
                <td class="titleCell">소속</td>
                <td class="titleCell">직종</td>
                <td class="titleCell">성명</td>
                <td class="titleCell">서명</td>
                <td class="titleCell">비고</td>
              </tr>
              <tr v-for="index in 20" :key="index + 20">
                <td>{{ index + 20 }}</td>
                <td>{{ typeof form.signatureList[index + 20 - 1] !== "undefined" ? form.signatureList[index + 20 - 1].target : "" }}</td>
                <td>{{ typeof form.signatureList[index + 20 - 1] !== "undefined" ? form.signatureList[index + 20 - 1].class : "" }}</td>
                <td>{{ typeof form.signatureList[index + 20 - 1] !== "undefined" ? form.signatureList[index + 20 - 1].name : "" }}</td>
                <td style="width: 1%; white-space: nowrap; min-width: 90px; padding: 2px">
                  <img v-if="typeof form.signatureList[index + 20 - 1] !== 'undefined'" height="50" :src="form.signatureList[index + 20 - 1].sign" />
                </td>
                <td>{{ typeof form.signatureList[index + 20 - 1] !== "undefined" ? form.signatureList[index + 20 - 1].note : "" }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>

    <!-- 사진대지 -->
    <h1 class="titleFull">안전교육 사진대지</h1>
    <div v-for="photo in form.photoList" :key="photo.id" v-if="photo.path" class="mb-6 photoWrap">
      <div class="photoContainer">
        <img height="600" :src="photo.path" :alt="photo.input" />
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-2">
        <div class="col-span-12 flex items-start">
          <span class="print-input"> {{ photo.input }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print107",
  props: {
    form: Object,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
$approval-border: 2px solid #cdcdcd;
$title-bg-color: #f9f9f9;
.bordered {
  border: 1px solid $border-color;
}
.titleCell {
  background-color: $title-bg-color;
  text-align: center;
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  .signTitle {
    width: 125px;
    height: 38px;
  }
  .signBody {
    height: 100px;
    border-bottom: 0;
  }
}
.contentTable {
  td {
    border: 1px solid $border-color;
    padding: 19px 14px;
  }
  .titleCell {
    width: 180px;
    padding: 19px 0;
    font-size: 14px;
    font-weight: 500;
  }
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.attendeeTable {
  td {
    height: 60px;
    border: 1px solid $border-color;
    text-align: center;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
  }
}
.photoWrap:nth-child(2n) {
  page-break-after: always;
}
img {
  -webkit-print-color-adjust: exact;
}
.pageBreak {
  page-break-after: always;
}
</style>
